import { render, staticRenderFns } from "./AdminItemTable.vue?vue&type=template&id=0e76a8d8&scoped=true&"
import script from "./AdminItemTable.vue?vue&type=script&lang=js&"
export * from "./AdminItemTable.vue?vue&type=script&lang=js&"
import style0 from "./AdminItemTable.vue?vue&type=style&index=0&id=0e76a8d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e76a8d8",
  null
  
)

export default component.exports